import { Affirmation } from "../../interfaces/tell_me/affirmation.types";
import { AffirmationWithCategory } from "../../interfaces/tell_me/affirmationWithCategory.types";
import { Category } from "../../interfaces/tell_me/category.types";
import { ReelWithCategory } from "../../interfaces/tell_me_watch/reel.types";
import { ReelsCategory } from "../../interfaces/tell_me_watch/reelsCategory.types";
import { ActionInterface } from "../actions/actions";
import { actionTypes } from "../actions/action_types";
import { AppState, INITIAL_STATE } from "../store";

interface HelpSetAffirmationAndCategoryTypes {
    affirmations: AffirmationWithCategory[],
    categories: Category[],
}
const helpSetAffirmationAndCategory = (state: AppState, payload: HelpSetAffirmationAndCategoryTypes): AppState => {
    return {
        ...state,
        affirmations: payload.affirmations,
        categories: payload.categories,
    };
}

interface HelpSetReelsAndReelsCategoriesTypes {
    reels: ReelWithCategory[],
    reelsCategories: ReelsCategory[],
}
const helpSetReelsAndReelsCategories = (state: AppState, payload: HelpSetReelsAndReelsCategoriesTypes): AppState => {
    return {
        ...state,
        reels: payload.reels,
        reelsCategories: payload.reelsCategories,
    };
}


const reducer = (state = INITIAL_STATE, action: ActionInterface): AppState => {
    switch (action.type) {
        case actionTypes.SET_AFFIRMATION_AND_CATEGORIES:
            return helpSetAffirmationAndCategory(state, action.payload)

        case actionTypes.SET_REELS_AND_REELS_CATEGORIES:
            return helpSetReelsAndReelsCategories(state, action.payload)

        default:
            return INITIAL_STATE;

    }
}

export default reducer;